function selectFallbackCat(siteName: string) {
  let selectedImage: any;
  switch (siteName) {
    case 'searchCRM':
    case 'searchEnterpriseSoftwareDE':
    case 'searchFinancialApplications':
    case 'searchWinDevelopment':
    case 'searchWinIT':
      selectedImage = 'businessApp';
      break;
    case 'searchCIO':
    case 'searchCIO-Midmarket':
    case 'searchCIOAU':
    case 'searchCIOCN':
    case 'searchCIOIN':
      selectedImage = 'cioExecutive';
      break;
    case 'searchSoftwareQuality':
      selectedImage = 'softwareQuality';
      break;
    case 'searchSAP':
      selectedImage = 'sap';
      break;
    case 'searchContentManagement':
      selectedImage = 'contentManagement';
      break;
    case 'searchCustomerExperience':
      selectedImage = 'customerExperience';
      break;
    case 'searchManufacturingERP':
    case 'searchERP':
      selectedImage = 'erp';
      break;
    case 'searchHRSoftware':
      selectedImage = 'HRSoftware';
      break;
    case 'DevOpsAgenda':
    case 'StrategiesCloudFR':
    case 'searchAWS':
    case 'searchAppArchitecture':
    case 'searchCloudApplications':
    case 'searchCloudComputing':
    case 'searchCloudComputingCN':
    case 'searchCloudProvider':
    case 'searchCloudStorage':
    case 'searchMobileComputing':
      selectedImage = 'cloudDevops';
      break;
    case 'cloudProvider':
      selectedImage = 'cloudProvider';
      break;
    case 'appArchitecture':
      selectedImage = 'appArchitecture';
      break;
    case 'aws':
    case 'searchAws':
      selectedImage = 'aws';
      break;
    case 'ComputerWeekly':
    case 'ComputerWeeklyBR':
    case 'ComputerWeeklyDE':
    case 'ComputerWeeklyES':
      selectedImage = 'computerWeekly';
      break;
    case 'TheServerSideCOM':
    case 'TheServerSideNET':
    case 'searchConvergedInfrastructure':
    case 'searchDataBackup':
    case 'searchDataCenter':
    case 'searchDataCenterCN':
    case 'searchDataCenterDE':
    case 'searchDataCenterES':
    case 'searchDataCenterIN':
    case 'searchEnterpriseDesktop':
    case 'searchEnterpriseLinux':
    case 'searchExchange':
    case 'searchSQLServer':
    case 'searchServerVirtualization':
    case 'searchVirtualCN':
    case 'searchVirtualDataCentreUK':
    case 'searchVirtualDesktop':
    case 'searchVirtualStorage':
    case 'searchWindowsServer':
      selectedImage = 'dataCenter';
      break;
    case 'BitpipeBR':
    case 'BrianMadden':
    case 'MicroscopeUK':
    case 'WhatIs':
    case 'WhatIsDE':
    case 'WhatIsFR':
    case 'ebizQ':
    case 'search400':
    case 'searchDomino':
    case 'searchITChannel':
    case 'searchITOperations':
    case 'searchSMBCN':
    case 'searchSOACN':
    case 'searchSVCN':
    case 'searchSystemsChannel':
    case 'searchVMware':
      selectedImage = 'genericMulti';
      break;
    case 'searchHealthIT':
      selectedImage = 'healthcareXtelligent';
      break;
    case 'searchBICN':
    case 'searchBusinessAnalytics':
    case 'searchBusinessIntelligenceIN':
    case 'searchDatabaseCN':
    case 'searchMicroservices':
      selectedImage = 'informationManagement';
      break;
    case 'searchDataManagement':
    case 'searchDataManagementUK':
      selectedImage = 'dataManagement';
      break;
    case 'searchOracle':
      selectedImage = 'oracle';
      break;
    case 'searchEnterpriseAI':
      selectedImage = 'enterpriseAi';
      break;
    case 'LeMagIT':
      selectedImage = 'leMagIT';
      break;
    case 'IoTAgenda':
    case 'searchEnterpriseWAN':
    case 'searchNetworking':
    case 'searchNetworkingCN':
    case 'searchNetworkingChannel':
    case 'searchNetworkingDE':
    case 'searchNetworkingUK':
    case 'searchSDN':
    case 'searchTelecom':
    case 'searchUnifiedCommunications':
      selectedImage = 'networking';
      break;
    case 'unifiedCommunications':
      selectedImage = 'unifiedCommunications';
      break;
    case 'searchCloudSecurity':
    case 'searchCompliance':
    case 'searchFinancialSecurity':
    case 'searchMidmarketSecurity':
    case 'searchSecurity':
    case 'searchSecurityAU':
    case 'searchSecurityCN':
    case 'searchSecurityChannel':
    case 'searchSecurityDE':
    case 'searchSecurityIN':
    case 'searchSecurityUK':
      selectedImage = 'security';
      break;
    case 'compliance':
      selectedImage = 'compliance';
      break;
    case 'searchDisasterRecovery':
    case 'searchSMBStorage':
    case 'searchSolidStateStorage':
    case 'searchStorage':
    case 'searchStorageAU':
    case 'searchStorageCN':
    case 'searchStorageChannel':
    case 'searchStorageDE':
    case 'searchStorageUK':
      selectedImage = 'storage';
      break;
    case 'searchSustainability':
      selectedImage = 'sustainability';
      break;
    default:
      selectedImage = 'genericMulti';
      break;
  }
  return selectedImage;
}
export default selectFallbackCat;